export default class CINUtils {
    static toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
        })
    }

    static async toFile(base64, extension) {
        let res = await fetch(base64)
        let buf = await res.arrayBuffer()
        return new File([buf], null, { type: extension })
    }

    static matchText(search, target) {
        if (typeof search != 'string' || typeof target != 'string') {
            return false
        }

        const normalizedSearch = search
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        const normalizedTarget = target
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return normalizedTarget.includes(normalizedSearch)
    }
}
